import hotIcon from "../assets/icons/icon-exclusive.png?format=webp";
import sportsIcon from "../assets/icons/icon-sport.png?format=webp";
import casinoIcon from "../assets/icons/icon-casino.png?format=webp";
import slotIcon from "../assets/icons/icon-slot.png?format=webp";
import TableIcon from "../assets/icons/icon-table.png?format=webp";
import fishicon from "../assets/icons/icon-fish.png?format=webp";
import crashIcon from "../assets/icons/icon-crash.png?format=webp";
import arcadeIcon from "../assets/icons/icon-arcade.png?format=webp";
import lotteryIcon from "../assets/icons/icon-lottery.png?format=webp";

import homeIcon from "../assets/icons/toolbar-icon-home.svg";
import promotionIcon from "../assets/icons/toolbar-icon-promotion.svg";
import withdrawIcon from "../assets/icons/toolbar-icon-deposit.svg";
import myaccountIcon from "../assets/icons/toolbar-icon-mine.svg";





import loginBanner1 from "../assets/images/login-banner1.webp";
import loginBanner2 from "../assets/images/login-banner2.webp";
import loginBanner3 from "../assets/images/login-banner3.webp";

import iconExchange from "../assets/icons/icon-exchange.svg";
import iconSportbook from "../assets/icons/icon-sportbook.svg";
import iconHorsebook from "../assets/icons/icon-horsebook.svg";
import velkieLogo from "../assets/icons/logo-velki.png?format=webp";
import iconSboSport from "../assets/icons/icon-sbov2.svg";
import iconEsports from "../assets/icons/icon-awcme1sport.svg";

import Jili from "../assets/images/jilii.png?format=webp";
import esport from "../assets/images/E1SPORT.webp";
import btg from "../assets/images/btg.png?format=webp";
import iconhotroad from "../assets/images/hotroad.png?format=webp";
import fc from "../assets/images/fc.png?format=webp";
import jdb from "../assets/images/jdb.png?format=webp";
import km from "../assets/images/km.png?format=webp";
import pg from "../assets/images/pg.png?format=webp";
import pt from "../assets/images/pt.png?format=webp";
import rt from "../assets/images/REDTIGER.webp";
import sexy from "../assets/images/SEXYBCRT.webp";
import sg from "../assets/images/SPADEGAMING.webp";
import evo from "../assets/images/evo.png?format=webp";
import sv388 from "../assets/images/SV388.webp";
import pp from "../assets/images/pp.png?format=webp";
import yesbingo from "../assets/images/provider-awcmyesbingo.png?format=webp";
import netent from "../assets/images/provider-netent.png?format=webp";
import nlcLogo from "../assets/images/nl-yellow.svg";
import fastspin from "../assets/images/FASTSPIN.webp";
import joker from "../assets/images/provider-joker.png?format=webp";
import p8 from "../assets/images/provider-awcmp8.png?format=webp";
import dragonsoft from "../assets/images/DRAGONSOFT.webp";
import spribe from "../assets/images/SPRIBE.webp";
import betgames from "../assets/images/BETGAMES.webp";

import pakistanFlag from "../assets/images/flag-symbolism-Pakistan-design-Islamic.png?format=webp";
import camodiaFlag from "../assets/images/Flag-Cambodia.png?format=webp";
import philippinesFlag from "../assets/images/Flag_of_philippines.svg.jpg";
import brazilFlag from "../assets/images/Flag_of_Brazil.svg.png?format=webp";
import indiaFlag from "../assets/images/Flag_of_India.svg.png?format=webp";
import bangladeshFlag from "../assets/images/Flag_of_Bangladesh.svg.png?format=webp";

// feature games

import feature1 from "../assets/images/features/feature1.webp";
import feature2 from "../assets/images/features/feature2.webp";
import feature3 from "../assets/images/features/feature3.webp";
import feature4 from "../assets/images/features/feature4.webp";
import feature5 from "../assets/images/features/feature5.webp";
import feature6 from "../assets/images/features/feature6.webp";
import feature7 from "../assets/images/features/feature7.webp";
import f1 from "../assets/images/features/feature-1.webp";
import f2 from "../assets/images/features/feature-2.webp";
// hotgame Image
import hot1 from "../assets/images/hot-casino/aviator.webp";
import hot2 from "../assets/images/hot-casino/JILI-TABLE-030.webp";
import hot3 from "../assets/images/hot-casino/JILI-TABLE-047.webp";
import hot4 from "../assets/images/hot-casino/JILI-TABLE-035.webp";
import hot5 from "../assets/images/hot-casino/KM-TABLE-021.webp";

import hot6 from "../assets/images/hot-casino/KM-TABLE-015.webp";
import hot7 from "../assets/images/hot-casino/KM-TABLE-022.webp";

import hot8 from "../assets/images/hot-casino/KM-TABLE-028.webp";
import hot9 from "../assets/images/hot-casino/KM-TABLE-060.webp";


import hot10 from "../assets/images/hot-casino/pgdragon.webp";

const obj = {
  user_status: {
    owner: "OW",
    sub_owner: "SOW",
    super_admin: "SUA",
    admin: "AD",
    sub_admin: "SAD",
    senior_super: "SSM",
    super_agent: "SA",
    agent: "AG",
    user: "CL",
  },
  user_next_status: {
    owner: "sub_owner",
    sub_owner: "super_admin",
    super_admin: "admin",
    admin: "sub_admin",
    sub_admin: "senior_super",
    senior_super: "super_agent",
    super_agent: "agent",
    agent: "user",
  },
  market_category: {
    1: "Market",
    3: "Bookmakers",
    5: "ManualOdds",
    10: "Win Toss",
    2: "Session",
    6: "Over by Over Session Market",
    7: "Player",
    9: "Wicket",
    11: "Bowler Session",
    8: "Last Digit ODD",
    4: "LineMarket",
    14: "Premium ODDs",
  },
  betCheckObj: {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  },
  matchType: {
    cricket: "Cricket",
    tennis: "Tennis",
    soccer: "Soccer",
    casino: "Casino",
  },
};
export default obj;
export const priceFormat = (value) => {
  return new Intl.NumberFormat().format(value);
};
export const LoginBanner = [
  { id: 1, banner: loginBanner1 },
  { id: 2, banner: loginBanner2 },
  { id: 3, banner: loginBanner3 },
];
export const CountryFlagBanner = [
  { id: 1, banner: pakistanFlag, title: "Pakistan" },
  { id: 2, banner: camodiaFlag, title: "camodia" },
  { id: 3, banner: philippinesFlag, title: "philippines" },
  { id: 4, banner: brazilFlag, title: "brazil" },
  { id: 5, banner: indiaFlag, title: "india" },
  { id: 6, banner: bangladeshFlag, title: "bangladesh" },
];

export const FeaturedGames = [
  {
    id: 1,
    icons: feature1,
    title: "Crazy Time",
    titlebn: "পাগলামী সময়",
    gameTypeCheck: "platForm",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
  },
  {
    id: 2,
    icons: feature2,
    title: "7up7down",
    titlebn: "7 আপ 7 ডাউন",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-011",
  },

  {
    icons: feature3,
    title: "Cricket King 18",
    titlebn: "ক্রিকেট কিং ১৮",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-078",
  },
  {
    icons: feature4,
    title: "Super Ace",
    titlebn: "সুপার এস",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-027",
  },
  {
    icons: feature5,
    title: "Wild Ace",
    titlebn: "বন্য টেক্কা",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-075",
  },
  {
    icons: feature6,
    title: "CrazySeven",
    titlebn: "ক্রেজি সেভেন",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-014",
  },
  {
    icons: feature7,
    title: "Cricket Sah 75",
    titlebn: "ক্রিকেট সাহ 75",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-082",
  },
  
];


export const IndiaCasinoGames = [
  {
    id: 1,
    icons: '/assets/casinoHome/img1.webp',
    title: "Crazy Time",
    titlebn: "পাগলামী সময়",
    gameTypeCheck: "platForm",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
  },
  {
    id: 2,
    icons: '/assets/casinoHome/img2.webp',
    title: "7up7down",
    titlebn: "7 আপ 7 ডাউন",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-011",
  },

  {
    icons: '/assets/casinoHome/img3.webp',
    title: "Cricket King 18",
    titlebn: "ক্রিকেট কিং ১৮",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
  },
  {
    icons: '/assets/casinoHome/img4.webp',
    title: "Super Ace",
    titlebn: "সুপার এস",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-027",
  },
  {
    icons: '/assets/casinoHome/img5.webp',
    title: "Wild Ace",
    titlebn: "বন্য টেক্কা",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-075",
  },
  {
    icons: '/assets/casinoHome/img6.webp',
    title: "CrazySeven",
    titlebn: "ক্রেজি সেভেন",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-014",
  },
  {
    icons: '/assets/casinoHome/img7.webp',
    title: "Cricket Sah 75",
    titlebn: "ক্রিকেট সাহ 75",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-082",
  },
  {
    icons: '/assets/casinoHome/img8.webp',
    title: "Cricket Sah 75",
    titlebn: "ক্রিকেট সাহ 75",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-082",
  },
  {
    icons: '/assets/casinoHome/img9.webp',
    title: "Cricket Sah 75",
    titlebn: "ক্রিকেট সাহ 75",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-082",
  },
  {
    icons: '/assets/casinoHome/img10.webp',
    title: "Cricket Sah 75",
    titlebn: "ক্রিকেট সাহ 75",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-082",
  },
  {
    icons: '/assets/casinoHome/img11.webp',
    title: "Cricket Sah 75",
    titlebn: "ক্রিকেট সাহ 75",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-082",
  },
  
];

export const SlotData = [
  {
    id: 1,
    icons: '/assets/images/fav/spribe.webp',
    title: "Skyward",
    titlebn: "আকাশমুখী",
    gameTypeCheck: "platForm",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
  },
  {
    id: 2,
    icons: '/assets/images/fav/aviator.webp',
    title: "Skyward",
    titlebn: "আকাশমুখী",
    gameTypeCheck: "platForm",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
  },
  {
    id: 3,
    icons: '/assets/images/fav/crazy.webp',
    title: "Crazy777",
    titlebn: "পাগল777",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType:"JILI-SLOT-014"
  },
  // {
  //   id: 3,
  //   icons: f3,
  //   title: "Elemental Link Fire",
  //   titlebn: "জিলি",
  //   gameTypeCheck: "platForm",
  //   gameType: "SLOT",
  //   platForm: "JILI",
  // },
  // {
  //   id: 4,
  //   icons: f4,
  //   title: "SuperNiubi",
  //   titlebn: "পৃ",
  //   gameTypeCheck: "platForm",
  //   gameType: "SLOT",
  //   platForm: "PP",
  // },
  // {
  //   id: 5,
  //   icons: f5,
  //   title: "Supermarket Spree",
  //   titlebn: "কোদাল",
  //   gameTypeCheck: "platForm",
  //   gameType: "SLOT",
  //   platForm: "SPADE",
  // },{
  //   id: 6,
  //   icons: f6,
  //   title: "Cocktail Nights",
  //   titlebn: "কোদাল",
  //   gameTypeCheck: "platForm",
  //   gameType: "SLOT",
  //   platForm: "SPADE",
  // },{
  //   id: 5,
  //   icons: f7,
  //   title: "Asgardian Rising",
  //   titlebn: "কোদাল",
  //   gameTypeCheck: "platForm",
  //   gameType: "SLOT",
  //   platForm: "SPADE",
  // }
];

export const footerAccountMenu = [
  {
    id: 1,
    icons: homeIcon,
    title: "Home",
    link: "/",
    titlebn: "জমা",
  },
  {
    id: 1,
    icons: promotionIcon,
    title: "Promotions",
    link: "/promotions",
    titlebn: "জমা",
  },
  {
    id: 2,
    icons: withdrawIcon,
    title: "Deposit",
    link: "/deposit",
    titlebn: "প্রত্যাহার করুন",
  },
  {
    id: 2,
    icons: myaccountIcon,
    title: "My Account",
    link: "/myaccount",
    titlebn: "প্রত্যাহার করুন",
  },
];
export const casinoMainMenu = [
  // {
  //   id: 1,
  //   icons: hotIcon,
  //   title: "Exclusive",
  //   type: "exclusive",
  //   titlebn: "গরম খেল",
  // },
  {
    id: 1,
    icons: 'data:image/png;base64,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',
    title: "Sports",
    type: "sports",
    titlebn: "স্পোর্টস",
    position: "translate(5px, -7px)",
  },
  {
    id: 2,
    icons: 'data:image/png;base64,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',
    title: "Casino",
    titlebn: "ক্যাসিনো",
    type: "casino",
    position: "translate(-5px, 2px)",
  },
  {
    id: 3,
    icons: 'data:image/png;base64,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',
    title: "Slot",
    titlebn: "স্লট",
    type: "slot",
    position: "translate(-1px, -7px)",
  },

  {
    id: 4,
    icons: "data:image/png;base64,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",
    title: "Table",
    titlebn: "টেবিল",
    type: "table",
    position: "translate(-9px, 3px)",
  },
  {
    id: 6,
    icons: "data:image/png;base64,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",
    title: "Crash",
    titlebn: "ক্র্যাশ",
    type: "crash",
    position: "translate(-5px, 2px)",
  },

  {
    id: 7,
    icons: "data:image/png;base64,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",
    title: "Fishing",
    titlebn: "মাছ ধরা",
    type: "fishing",
    position: "translate(-4px, -5px)",
  },

  // {
  //   id: 5,
  //   icons: arcadeIcon,
  //   title: "Arcade",
  //   type: "arcade",
  //   titlebn: "স্পোর্টসবুক",
  // },

  {
    id: 6,
    icons: "data:image/png;base64,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",
    title: "Lottery",
    titlebn: "ভার্চুয়াল",
    type: "lottery",
    position: "translate(-7px, 9px)",
  },
];
export const casinoMenu = [
  {
    id: 1,
    title: "Exclusive",
    key: "exclusive",
    titlebn: "গরম খেল",

      
      array: [
        {
          id: 1,
          image:  hot1,
          title: "aviator",
          type: "aviator",
          gameTypeCheck: "platForm",
          platForm: "SPRIBE",
          gameType: "EGAME",
          casinoType: "SPRIBE-EGAME-001",
        },
        {
          id: 1,
          image: hot2,
          title: "Go Rush",
          type: "Go Rush",
          gameTypeCheck: "platForm",
          platForm: "JILI",
          gameType: "TABLE",
          casinoType: "JILI-TABLE-030",
        },
        {
          id: 2,
          image: hot3,
          title: "Crash Bonus",
          type: "Crash Bonus",
          gameTypeCheck: "platForm",
          platForm: "JILI",
          gameType: "TABLE",
          casinoType: "JILI-TABLE-047",
        },
        {
          id: 3,
          image: hot4,
          title: "Limbo",
          type: "Limbo",
          gameTypeCheck: "platForm",
          platForm: "JILI",
          gameType: "TABLE",
          casinoType: "JILI-TABLE-035",
        },
        {
          id: 4,
          image: hot5,
          title: "Number Matka",
          type: "Number Matka",
          gameTypeCheck: "platForm",
          platForm: "KINGMAKER",
          gameType: "TABLE",
          casinoType: "KM-TABLE-021",
        },
        {
          id: 5,
          image: hot6,
          title: "Sicbo",
          type: "Sicbo",
          gameTypeCheck: "platForm",
          platForm: "KINGMAKER",
          gameType: "TABLE",
          casinoType: "KM-TABLE-015",
        },
      
       
        {
          id:7,
          image: hot7,
          title: "Card Matka",
          type: "Card Matka",
          gameTypeCheck: "platForm",
          platForm: "KINGMAKER",
          gameType: "TABLE",
          casinoType: "KM-TABLE-022",
        },
        {
          id: 8,
          image: hot8,
          title: "7 Up 7 Down",
          type: "7 Up 7 Down",
          gameTypeCheck: "platForm",
          platForm: "KINGMAKER",
          gameType: "TABLE",
          casinoType: "KM-TABLE-028",
        },
        {
          id: 9,
          image: hot9,
          title: "Ludo",
          type: "Ludo",
          gameTypeCheck: "platForm",
          platForm: "KINGMAKER",
          gameType: "TABLE",
          casinoType: "KM-TABLE-060",
        },
        {
          id: 10,
          image: hot10,
          title: "Dragon ",
          type: "Dragon Tiger",
          gameTypeCheck: "platForm",
          platForm: "PG",
          gameType: "SLOT",
          casinoType: "PG-SLOT-035",
        },
  
      ],
  },
  {
    id: 1,
    title: "Sports",
    key: "sports",
    titlebn: "বিনিময়",
    array: [
      // {
      //   image: iconExchange,
      //   title: "Exchange",
      //   gameTypeCheck: "sports",
      //   link: `${import.meta.env.VITE_SKY_URL}bkash/${localStorage.getItem(
      //     "token"
      //   )}`,
      // },
      // {
      //   image: velkieLogo,
      //   title: "Velki",
      //   gameTypeCheck: "sports",
      //   link: `${import.meta.env.VITE_VELKIE_URL}bkash/${localStorage.getItem(
      //     "token"
      //   )}`,
      // },
      // {
      //   image: iconSportbook,
      //   title: "Sportbook",
      //   link: "",
      //   gameTypeCheck: "platForm",
      //   platForm: "SABA",
      //   gameType: "VIRTUAL",
      //   casinoType: "SABA-VIRTUAL-001",
      // },
      // {
      //   image: iconSboSport,
      //   title: "SBO Sports",
      //   link: "",
      //   gameTypeCheck: "platForm",
      //   platForm: "SABA",
      //   gameType: "VIRTUAL",
      //   casinoType: "SABA-VIRTUAL-001",
      // },
      // {
      //   image: iconHorsebook,
      //   title: "Horsebook",
      //   link: "",
      //   gameTypeCheck: "platForm",
      //   platForm: "HORSEBOOK",
      //   gameType: "LIVE",
      //   casinoType: "HRB-LIVE-001",
      // },
      // {
      //   image: iconEsports,
      //   title: "E1sports",
      //   link: "",
      //   gameTypeCheck: "platForm",
      //   gameType: "ESPORTS",
      //   platForm: "E1SPORT",
      //   casinoType: "E1-ESPORTS-001",
      // },
      {
        image: '/assets/sports/cricket.png?format=webp',
        title: "Cricket",
        gameTypeCheck: "sports",
        link: `${import.meta.env.VITE_SKY_URL}bkash/${localStorage.getItem(
          "token"
        )}`,
      },
      {
        image: '/assets/sports/soccer.webp',
        title: "Soccer",
        gameTypeCheck: "sports",
        link: `${import.meta.env.VITE_SKY_URL}bkash/${localStorage.getItem(
          "token"
        )}`,
      },
      {
        image: '/assets/sports/tennis.webp',
        title: "Tennis",
        gameTypeCheck: "sports",
        link: `${import.meta.env.VITE_SKY_URL}bkash/${localStorage.getItem(
          "token"
        )}`,
      },
      {
        image: '/assets/sports/sport.webp',
        title: "E1SPORT",
        gameTypeCheck: "sports",
        link: `${import.meta.env.VITE_SKY_URL}bkash/${localStorage.getItem(
          "token"
        )}`,
      },
      {
        image: '/assets/sports/hourse.png?format=webp',
        title: "Horse",
        gameTypeCheck: "sports",
        link: `${import.meta.env.VITE_SKY_URL}bkash/${localStorage.getItem(
          "token"
        )}`,
      },
      {
        image: '/assets/sports/sb.png?format=webp',
        title: "SV388",
        gameTypeCheck: "sports",
        link: `${import.meta.env.VITE_SKY_URL}bkash/${localStorage.getItem(
          "token"
        )}`,
      },
      {
        image: '/assets/sports/pin.webp',
        title: "PINNACLE",
        gameTypeCheck: "sports",
        link: `${import.meta.env.VITE_SKY_URL}bkash/${localStorage.getItem(
          "token"
        )}`,
      },
      {
        image: '/assets/sports/saba.png?format=webp',
        title: "SABA",
        gameTypeCheck: "sports",
        link: `${import.meta.env.VITE_SKY_URL}bkash/${localStorage.getItem(
          "token"
        )}`,
      },
    ],
  },
  {
    id: 2,
    title: "Casino",
    key: "casino",
    titlebn: "লাইভ ক্যাসিনো",
    array: [
      {
        image: evo,
        title: "EVOLUTION",
        type: "evo",
        key: "live",

        platForm: "EVOLUTION",
        gameType: "LIVE",
        casinoType: "EVOLUTION-LIVE-006",
        isLobbyTrue: true,
      },
      {
        image: sexy,
        title: "SEXYBCRT",
        type: "sexy",
        key: "live",

        platForm: "SEXYBCRT",
        gameType: "LIVE",
        casinoType: "MX-LIVE-006",
        isLobbyTrue: true,
      },

      {
        image: iconhotroad,
        title: "HOTROAD",
        type: "hotroad",
        key: "live",

        platForm: "HOTROAD",
        gameType: "LIVE",
        casinoType: "HOTROAD-LIVE-001",
        isLobbyTrue: true,
      },
      {
        image: "data:image/png;base64,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",
        title: "PLAYTECH",
        type: "pt",
        key: "live",
        platForm: "PT",
      },

      {
        image: betgames,
        title: "BG",
        type: "bg",
        key: "live",

        platForm: "BG",
        gameType: "LIVE",
        casinoType: "",
      },

      {
        image: pp,
        title: "PP",
        type: "pp",
        key: "live",
        platForm: "PP",
        gameType: "LIVE",
        casinoType: "PP-LIVE-001",
      },

      {
        image: esport,
        title: "E1SPORT",
        type: "e1sports",
        key: "live",
        gameTypeCheck: "platForm",
        gameType: "ESPORTS",
        platForm: "E1SPORT",
        casinoType: "E1-ESPORTS-001",
      },

      {
        image: sv388,
        title: "SV388",
        type: "sv",
        key: "live",
        gameTypeCheck: "platForm",
        platForm: "SV388",
        gameType: "LIVE",
        casinoType: "SV-LIVE-001",
      },
    ],
  },
  {
    id: 2,
    title: "Slot",
    key: "slot",
    titlebn: "স্লট",
    array: [
      {
        image: Jili,
        title: "JILI",
        type: "jili",
        key: "slot",

        gameType: "SLOT",
        platForm: "JILI",
      },
      {
        image: pg,
        title: "PG",
        type: "pg",
        key: "slot",

        gameType: "SLOT",
        platForm: "PG",
      },
      {
        image: jdb,
        title: "JDB",
        type: "jdb",
        key: "slot",

        gameType: "SLOT",
        platForm: "JDB",
      },

      {
        image: fastspin,
        title: "FASTSPIN",
        type: "FastSpin",
        key: "slot",

        gameType: "SLOT",
        platForm: "FASTSPIN",
      },

      {
        image: fc,
        title: "FC",
        type: "fc",
        key: "slot",

        gameType: "SLOT",
        platForm: "FC",
      },
      {
        image: sg,
        title: "SG",
        type: "spade",
        key: "slot",

        gameType: "SLOT",
        platForm: "SPADE",
      },
      {
        image: yesbingo,
        title: "Yes Bingo",
        type: "yesbingo",
        key: "slot",

        gameType: "SLOT",
        platForm: "YESBINGO",
      },
      {
        image: rt,
        title: "RT",
        type: "rt",
        key: "slot",

        gameType: "",
        platForm: "RT",
      },
      {
        image: "data:image/png;base64,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",
        title: "PT",
        type: "pt",
        key: "slot",

        gameType: "SLOT",
        platForm: "PT",
      },

      {
        image: joker,
        title: "Joker",
        type: "Joker",
        key: "slot",

        gameType: "SLOT",
        platForm: "JOKER",
        casinoType: "",
      },

      {
        image: netent,
        title: "NETENT",
        type: "NETENT",
        key: "slot",

        gameType: "NETENT",
        platForm: "",
        casinoType: "",
      },

      {
        image: p8,
        title: "P8",
        type: "PLAYSTAR",
        key: "slot",

        gameType: "SLOT",
        platForm: "PLAY8",
        casinoType: "",
      },

      {
        image: btg,
        title: "BTG",
        type: "btg",
        key: "slot",

        gameType: "SLOT",
        platForm: "BTG",
      },

      {
        image: km,
        title: "KINGMAKER",
        type: "kingmaker",
        key: "slot",
        gameType: "SLOT",
        platForm: "KINGMAKER",
      },

      {
        image: pp,
        title: "PP",
        type: "pp",
        key: "slot",

        gameType: "SLOT",
        platForm: "PP",
      },
      {
        image: dragonsoft,
        title: "DRAGOONSOFT",
        type: "dragoonsoft",
        key: "slot",

        gameType: "SLOT",
        platForm: "DRAGOONSOFT",
      },

      {
        image: nlcLogo,
        title: "NLC",
        type: "NLC",
        key: "SLOT",

        platForm: "NLC",
        gameType: "SLOT",
      },
    ],
  },
  {
    id: 3,
    title: "Table",
    key: "table",
    titlebn: "টেবিল",
    array: [
      {
        image: Jili,
        title: "JILI",
        type: "jili",
        key: "table",

        gameType: "TABLE",
        platForm: "JILI",
      },
      {
        image: km,
        title: "KM",
        type: "kingmaker",
        key: "table",

        gameType: "TABLE",
        platForm: "KINGMAKER",
      },

      {
        image: spribe,
        title: "SPRIBE",
        type: "SPRIBE",
        key: "table",

        platForm: "SPRIBE",
        gameType: "",
        casinoType: "",
      },

      {
        image: pg,
        title: "PG",
        type: "pg",
        key: "TABLE",
        gameType: "SLOT",
        platForm: "PG",
        gameType: "TABLE",
      },

      {
        image: netent,
        title: "NETENT",
        type: "NETENT",
        key: "table",
        gameType: "TABLE",
        platForm: "NETENT",
        casinoType: "",
      },
    ],
  },
  {
    id: 1,
    title: "Crash",
    key: "crash",
    titlebn: "গরম খেল",
    array: [
      {
         image: spribe,
        title: "SPRIBE",
        type: "SPRIBE",
        key: "crash",
        // gameTypeCheck: "platForm",
        platForm: "SPRIBE",
        gameType: "",
        casinoType: "",
      },
      {
        image: Jili,
        title: "JILI",
        type: "jili",
        key: "crash",
        // gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "JILI",
      },
      {
        image: km,
        title: "KM",
        type: "kingmaker",
        key: "crash",
        // gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "KINGMAKER",
      },
      {
        image: pp,
        title: "PP",
        type: "pp",
        key: "crash",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "PP",
      },
    ],
  },
  {
    id: 4,
    title: "Fishing",
    key: "fishing",
    type: "fishing",
    array: [
      {
        image: Jili,
        title: "JILI",
        type: "jili",
        key: "fishing",
        gameType: "FH",
        platForm: "JILI",
      },

      {
        image: jdb,
        title: "JDB",
        type: "jdb",
        key: "fishing",
        gameType: "FH",
        platForm: "JDB",
      },
      {
        image: fc,
        title: "FC",
        type: "fc",
        key: "fishing",
        gameType: "FH",
        platForm: "FC",
      },

      {
        image: joker,
        title: "Joker",
        type: "Joker",
        key: "fishing",
        gameType: "FH",
        platForm: "JOKER",
        casinoType: "",
      },

      {
        image: yesbingo,
        title: "YELLOWBAT",
        type: "yl",
        key: "fishing",
        gameType: "FH",
        platForm: "YESBINGO",
      },

      {
        image: sg,
        title: "Spade",
        type: "spade",
        key: "fishing",
        gameType: "FH",
        platForm: "SPADE",
      },
    ],
  },

  {
    id: 6,
    title: "Arcade",
    key: "arcade",
    titlebn: "স্পোর্টসবুক",
    array: [
      {
        image: jdb,
        title: "JDB",
        type: "jdb",
        key: "arcade",
        gameType: "EGAME",
        platForm: "JDB",
      },
      {
        image: fc,
        title: "FC",
        type: "fc",
        key: "arcade",
        gameType: "EGAME",
        platForm: "FC",
      },
      {
        image: spribe,
        title: "SPRIBE",
        type: "SPRIBE",
        key: "arcade",
        gameType: "EGAME",
        platForm: "SPRIBE",
        casinoType: "",
      },
    ],
  },
  {
    id: 7,
    title: "Lottery",
    key: "lottery",
    titlebn: "খেলাধুলা",
    array: [
      {
        image: Jili,
        title: "JILI",
        type: "jili",
        key: "lottery",
        gameType: "FH",
        platForm: "JILI",
      },
      {
        image: km,
        title: "KM",
        type: "kingmaker",
        key: "lottery",
        gameType: "TABLE",
        platForm: "KINGMAKER",
      },
      {
        image: joker,
        title: "Joker",
        type: "Joker",
        key: "lottery",
        gameType: "SLOT",
        platForm: "JOKER",
        casinoType: "",
      },
      {
        image: yesbingo,
        title: "YellowBat",
        type: "yesbingo",
        key: "lottery",
        gameType: "FH",
        platForm: "YESBINGO",
      },
    ],
  },
];


export const validationRules = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,15}$/,
  newPass: /^[a-zA-Z0-9]{8,15}$/,
  newPassMessage:
    "Password must contain uppercase and lowercase characters, numbers and must be minimum 8 character long (without special character).",
  passwordMessage:
    "Password must contain uppercase and lowercase characters, numbers, special character and must be minimum 8 character long.",
  characters: /^[a-zA-Z_ ]*$/,
  numbers: /^[0-9]*$/,
  removeWhitespace: /^[a-zA-Z0-9]+$/,
  numberNew: /^[0-9]*$/,
  numberWithDot: /^\d*(\.\d{0,10})?$/,
};
export const preventMaxInput = (e) => {
  e.target.value = e.target.value.trimStart();
  e.target.value = e.target.value.replace(/  +/g, " ");
};
export const AmountArray = [
  { id: 1, amount: 100 },
  { id: 2, amount: 500 },
  { id: 3, amount: 1000 },
  { id: 4, amount: 5000 },
  { id: 5, amount: 1000 },
  { id: 6, amount: 15000 },
  { id: 7, amount: 20000 },
  { id: 8, amount: 25000 },
];

export const categoryArray = [
  { type: 2, name: "Session" },
  { type: 1, name: "Market" },
  { type: 3, name: "Bookmakers" },
  { type: 5, name: "ManualOdds" },
  { type: 10, name: "Win Toss" },
  { type: 6, name: "Over by Over Session Market" },
  { type: 7, name: "Player" },
  { type: 9, name: "Wicket" },
  { type: 11, name: "Bowler Session" },
  { type: 8, name: "Last Digit ODD" },
  { type: 4, name: "LineMarket" },
  { type: 14, name: "Premium ODDs" },
];
export const premiumCategoryArray = [
  { type: 1, name: "Popular" },
  { type: 3, name: "Match" },
  { type: 5, name: "Innings" },
  { type: 10, name: "Over" },
  { type: 2, name: "Batsman" },
  { type: 6, name: "Partnership" },
  { type: 7, name: "Group" },
  { type: 9, name: "Range" },
  { type: 11, name: "Head-to-Head" },
  { type: 8, name: "Player" },
];